<template>
  <div>
    <div class="cus-panel-heading">
      <h4 class="cus-panel-title">
        {{ makeOrderData.order_id ? $t('customer.updateOrderTitleWithNumber', { number: makeOrderData.theOrderID }) : $t('customer.requestOrderTitle') }}
      </h4>
    </div>

    <div
      v-if="false"
      class="col-dm-12 col-md-12 cus-orange-dark"
      style="margin-top: 10px ; border-top-style: solid; border-width: 2px;"
    >
      <div
        style="display: none"
        id="ware"
      >
        <div class="col-sm-12 col-md-5 col-md-offset-1">
          <h4><b>USA</b></h4>
          <h6><b>Username: </b>{{ loggedInUserData.full_name }}</h6>
          <h6>{{ usaWarehouse.street }}</h6>
          <!-- <h6><b>Zip code: </b>{{ usaWarehouse.code }}</h6> -->
          <h6>{{ usaWarehouse.state_province }}</h6>
          <h6>{{ usaWarehouse.phone_number }}</h6>
        </div>
        <!-- <div class="col-sm-12 col-md-6">
          <h4><b>Turkey</b></h4>
          <h6><b>Username: </b>{{ loggedInUserData.full_name }}</h6>
          <h6><b>{{ $t('columns.city') }}: </b>{{ turkeyWarehouse.city }}</h6>
          <h6><b>{{ $t('columns.postalCode') }}: </b>{{ turkeyWarehouse.code }}</h6>
          <h6><b>{{ $t('columns.stateProvince') }}: </b>{{ turkeyWarehouse.state_province }}</h6>
          <h6><b>{{ $t('columns.street') }}: </b>{{ turkeyWarehouse.street }}</h6>
          <h6><b>{{ $t('columns.houseNumber') }}: </b>{{ turkeyWarehouse.house_number }}</h6>
        </div> -->
      </div>
    </div>
    <div
      class="col-md-12 cus-orange-dark"
      style="border-bottom-style: solid; border-width: 2px;"
    ></div>

    <form
      action=""
      @submit.prevent="submitForm()"
    >
      <v-alert
        type="success"
        :value="checkAlert"
      >
        {{ $t('customer.orderRequestedSuccessfully') }}
      </v-alert>
      <v-alert
        type="error"
        :value="checkURL"
      >
        {{ $t('orders.urlFormatNotAcceptable') }}
      </v-alert>
      <v-container grid-list-md>
        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.productName') + '*'"
            v-model="makeOrderData.product_name"
            :error-messages="errors.collect('product_name')"
            v-validate="'required'"
            data-vv-name="product_name"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.productUrl') + '*'"
            v-model="makeOrderData.product_url"
            :error-messages="errors.collect('product_url')"
            v-validate="'required'"
            data-vv-name="product_url"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.quantity') + '*'"
            v-model="makeOrderData.quantity"
            :error-messages="errors.collect('quantity')"
            v-validate="'required|numeric|min_value:1'"
            data-vv-name="quantity"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-select
            :items="warehouses"
            v-model="makeOrderData.warehouse_id_fk"
            :error-messages="errors.collect('warehouse_id_fk')"
            data-vv-name="warehouse_id_fk"
            :label="$t('columns.warehouse') + '*'"
            v-validate="'required'"
            @input="handleSelectWarehouse(makeOrderData.warehouse_id_fk)"
          >
          </v-select>
        </div>

        <div class="col-md-5">
          <v-select
            :items="transportationTypes"
            item-value="id"
            item-text="name"
            v-model="makeOrderData.transportation_type"
            :error-messages="errors.collect('Transportation Type')"
            data-vv-name="Transportation Type"
            :label="$t('columns.transportationType') + '*'"
            v-validate="'required'"
          >
          </v-select>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.type')"
            v-model="makeOrderData.type"
            data-vv-name="type"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.size')"
            v-model="makeOrderData.size"
            data-vv-name="size"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('customer.color')"
            v-model="makeOrderData.color"
            data-vv-name="color"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.note')"
            v-model="makeOrderData.note"
            data-vv-name="note"
          >
          </v-text-field>
        </div>

        <div class="col-md-5">
          <v-text-field
            :label="$t('columns.coupon')"
            v-model="makeOrderData.coupon"
            data-vv-name="coupon"
          ></v-text-field>
          <span
            v-if="notCouponCode"
            style="color: red"
          >{{ $t('customer.couponCodeValidation') }}</span>
        </div>

        <!-- Repackage & Hold hidden for later use
        <div class="col-md-5">
          <div class="d-flex">
            <v-checkbox
              :label="$t('customer.repackage')"
              v-model="makeOrderData.is_repackage"
              class="ma-0 pa-0 mt-4"
              hide-details
            ></v-checkbox>

            <v-checkbox
              :label="$t('customer.hold')"
              v-model="makeOrderData.is_hold"
              class="ma-0 pa-0 mt-4"
              hide-details
            ></v-checkbox>
          </div>
        </div>
        -->

        <div class="col-md-5">
          <v-text-field
            :label="$t('customer.otherServiceSpecify')"
            v-model="makeOrderData.other_service"
            data-vv-name="other_service"
          >
          </v-text-field>
        </div>

        <div class="col-md-12 d-flex align-items-center">
            <!-- <div class="col-md-1" v-if="imagePreview" style="margin-right: 15px;"> -->
              <img v-if="checkImageOrEdit || imagePreview"
              :src="checkImageOrEdit ? `${$_image_path()}${makeOrderData.image}` : (imagePreview || '../../assets/images/shipzone.png')"
              :alt="$t('columns.preview')"
              style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
            />
          <!-- </div> -->
          <v-flex xs5 sm5 md10>
            <v-btn
            text flat
            color="orange"
            @click="triggerFileInput"
            style="margin: 16px; display: flex; align-items: center;"
          >
            {{ $t('orders.uploadImage') }}
          </v-btn>
          </v-flex>
          <span
            v-if="makeOrderData.fileName"
            style="display: flex; align-items: center;" class="rtl-ml-15"
          >
            {{ makeOrderData.fileName }}
          </span>
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            accept="image/*"
            v-validate="'max_file_size:2'"
            data-vv-name="file"
            @change="handleFileUpload"
          />
          <div v-if="errors.has('file')" style="color: red; display: block; margin-top: 5px;">
            {{ errors.first('file') }}
          </div>
        </div>

        <!--<div class="col-md-6">-->
        <!--<h5 class="lead" style="padding-top: 2%">-->
        <!--<input type="checkbox" v-model="makeOrderData.c_o_d" name="c_o_d" style="width:20px;height:20px;padding:10px" > &nbsp; Cash on deliver-->
        <!--</h5> -->
        <!--</div> -->
      </v-container>
      <v-spacer></v-spacer>
      <div class="col-sm-4 col-md-3 col-md-offset-6 submit-padding">
        <v-btn
          type="submit"
          :loading="loading"
          class="cus-custom-warning"
          style="width: 100%; height:auto; margin-bottom: 3%"
        >
          {{ makeOrderData.order_id ? $t('common.update') : $t('customer.requestButton') }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert'
import { Validator } from 'vee-validate'

Validator.extend('max_file_size', {
  getMessage: (field, params) => `The ${field} must not exceed ${params[0]} MB.`,
  params: ['size'],
  validate(value, args) {
    if (!value || !value.length) return true // No file selected
    const file = value[0]
    const size = parseFloat(args[0]) // Convert parameter to number
    if (!file || !file.size) return false
    return file.size <= size * 1024 * 1024 // Convert MB to bytes
  }
})

Validator.extend('url', {
  getMessage: (field) => `The ${field} must be a valid HTTP URL.`,
  validate(value) {
    if (!value) return true
    return /^https?:\/\/.+/.test(value)
  }
})

export default {
  // created() {
  //   let thePanel = document.querySelector('.panel-flat')
  //   thePanel.style.overflowX = 'hidden'
  // },

  mounted() {
    this.getLoggedInUser()
    this.getWarehouses()
    this.getWarehousesToSelect()
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }

    // if edit mode get order data
    if (
      window.location.search.replace('?order_id=', '') !== null ||
      window.location.search.replace('?order_id=', '') !== ''
    ) {
      this.theOrderId = Number(window.location.search.replace('?order_id=', ''))
      if (this.theOrderId && this.theOrderId > 0) {
        this.getOrder()
      }
    }
    // console.log(this.$route.query.order_id)
    // console.log(this.$route.query && this.$route.query.order_id ? 'true' : 'false')
    // if (this.$route)
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      makeNewOrderUrl: 'api/orders/customer-store',
      showWarehouseUrl: 'api/warehouses',
      loggedInUserData: {},
      theOrderId: null,
      checkAlert: false,
      checkURL: false,
      loading: false,
      notCouponCode: false,
      x: 1,
      usaWarehouse: [],
      turkeyWarehouse: [],
      transportationTypes: [],
      warehouses: [],
      deliveryTypes: [
        { text: 'Home Delivery', value: 'home delivery' },
        { text: 'Office Delivery', value: 'office delivery' }
      ],
      file: null,
      makeOrderData: {
        warehouse_id_fk: null,
        transportation_type: null,
        product_name: '',
        product_url: '',
        quantity: '',
        // delivery_type: "",
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        other_service: '',
        image: null,
        fileName: ''
      },
      imagePreview: null
    }
  },

  computed: {
    checkImageOrEdit() {
      return this.makeOrderData.order_id > 0 && this.file === null
    }
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      this.makeOrderData.image = null
      this.makeOrderData.fileName = ''
      this.$validator.errors.remove('file')
      const file = event.target.files[0]
      if (file && !this.errors.has('file')) {
        this.file = file
        this.makeOrderData.image = file
        this.makeOrderData.fileName = file.name
        this.imagePreview = URL.createObjectURL(file)
      } else {
        this.file = null
        this.makeOrderData.image = null
        this.imagePreview = null
      }
    },
    handleSelectWarehouse(id, selected) {
      this.makeOrderData.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }

      if (selected > 0) this.makeOrderData.transportation_type = selected
    },

    getOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/customer_order_detail/${this.theOrderId}`, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.makeOrderData = response.data.data[0]
          this.handleSelectWarehouse(this.makeOrderData.warehouse_id_fk, response.data.data[0].transportation_type_obj.id)
        })
    },

    getWarehousesToSelect() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data.data
          result.forEach(r => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2
        $('#ware').show('slow')
      } else if (this.x === 2) {
        this.x = 1
        $('#ware').hide('slow')
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.showWarehouseUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.usaWarehouse = response.data.data[0]
          this.turkeyWarehouse = response.data.data[1]
        })
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.makeOrderData.coupon && this.makeOrderData.coupon !== '') {
            if (this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              this.notCouponCode = false
              this.makeNewOrder()
            } else {
              this.notCouponCode = true
            }
          } else {
            this.notCouponCode = false
            this.makeNewOrder()
          }
        }
      })
    },

    makeNewOrder() {
      this.loading = true
      let token = localStorage.getItem('access_token')
      const formData = new FormData()

      // Append form data
      for (const key in this.makeOrderData) {
        formData.append(key, this.makeOrderData[key])
      }

      // edit
      if (this.makeOrderData.order_id) {
        formData.append('_method', 'PUT')
        axios
          .post(`api/update-order-by-customer/${this.makeOrderData.order_id}`, formData, {
            headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
          })
          .then(() => {
            this.checkURL = false
            this.loading = false
            this.checkAlert = true
            setTimeout(() => {
              this.clearNewOrerData()
              this.$router.push('/my-order')
            }, 2000)
          })
          .catch(error => {
            this.loading = false
            this.checkAlert = false
            if (error.response.data.message.product_url) {
              this.checkURL = true
            } else {
              this.checkURL = false
              swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
            }
          })
      } else { // add
        axios
          .post(this.makeNewOrderUrl, formData, {
            headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            this.checkURL = false
            this.loading = false
            this.checkAlert = true
            let a = this
            setTimeout(function () {
              a.clearNewOrerData()
            }, 2000)
          })
          .catch(error => {
            this.loading = false
            this.checkAlert = false
            if (error.response.data.message.product_url) {
              this.checkURL = true
            } else {
              this.checkURL = false
              swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
            }
          })
      }
    },

    clearNewOrerData() {
      this.makeOrderData.warehouse_id_fk = ''
      this.makeOrderData.transportation_type = null
      this.makeOrderData.product_name = ''
      this.makeOrderData.product_url = ''
      this.makeOrderData.quantity = ''
      this.makeOrderData.coupon = ''
      this.makeOrderData.size = ''
      this.makeOrderData.type = ''
      this.makeOrderData.color = ''
      this.makeOrderData.c_o_d = ''
      this.makeOrderData.is_repackage = false
      this.makeOrderData.is_hold = false
      this.makeOrderData.other_service = null
      this.makeOrderData.image = null
      this.checkAlert = false
      this.checkURL = false
      this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #c26f02;
  border-bottom: 0px solid #c26f02 !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/makeNewOrder.vue